import { render, staticRenderFns } from "./EventFeed.vue?vue&type=template&id=0a65a198&"
import script from "./EventFeed.vue?vue&type=script&lang=ts&"
export * from "./EventFeed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports